/**
 * Quick Stats Cards
 * Display summary statistics for instructor dashboard
 */

import { Card, CardContent } from '../ui/card';

interface QuickStatsCardsProps {
  activeClasses: number;
  totalStudents: number;
  provisionedClasses: number;
}

export function QuickStatsCards({
  activeClasses,
  totalStudents,
  provisionedClasses,
}: QuickStatsCardsProps) {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card>
        <CardContent className="p-6">
          <div className="text-2xl font-bold">{activeClasses}</div>
          <div className="text-sm text-muted-foreground">Active Classes</div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="text-2xl font-bold">{totalStudents}</div>
          <div className="text-sm text-muted-foreground">Total Students</div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="text-2xl font-bold">{provisionedClasses}</div>
          <div className="text-sm text-muted-foreground">Classes Provisioned</div>
        </CardContent>
      </Card>
    </div>
  );
}
